var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUmmahfyMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 612 370.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        filter: url(#drop-shadow-1);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -291.24,
    y1: -347.92,
    x2: 143.53,
    y2: 86.84,
    gradientTransform: "translate(406.21 291.79) scale(1.35 .82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c489b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#294594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#183268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#0d274d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a2343"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    x: 16.32,
    y: 16.08,
    width: 579.36,
    height: 337.92,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0a2343",
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: -0.25,
    width: 612.84,
    height: 370.71,
    rx: 35.3,
    ry: 35.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M531.53,125.79l-43.75-43.75c-3.56-3.56-8.4-5.57-13.44-5.57h-60.11c-7.5,0-13.59,6.08-13.59,13.59v190.34c0,7.5,6.08,13.59,13.59,13.59h54.4c7.5,0,13.59-6.08,13.59-13.59v-117.84c0-7.5,6.08-13.59,13.59-13.59h26.12c12.1,0,18.16-14.63,9.61-23.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M362.13,157.82h-108.85c-7.51,0-13.59,6.09-13.59,13.59v54.08c0,6.49-4.4,12.38-10.76,13.66-8.75,1.77-16.43-4.87-16.43-13.31V90.5c0-7.51-6.09-13.59-13.59-13.59h-108.85c-7.51,0-13.59,6.09-13.59,13.59v108.85c0,7.51,6.09,13.59,13.59,13.59h54.43c7.51,0,13.59,6.09,13.59,13.59v53.6c0,7.51,6.09,13.59,13.59,13.59h40.82v.13h149.63c7.51,0,13.59-6.09,13.59-13.59v-108.85c0-7.51-6.09-13.59-13.59-13.59ZM158.09,144.93c0,7.51-6.09,13.59-13.59,13.59h-.02c-7.51,0-13.59-6.09-13.59-13.59v-.02c0-7.51,6.09-13.59,13.59-13.59h.02c7.51,0,13.59,6.09,13.59,13.59v.02ZM321.31,225.85c0,7.51-6.09,13.59-13.59,13.59h-.02c-7.51,0-13.59-6.09-13.59-13.59v-.02c0-7.51,6.09-13.59,13.59-13.59h.02c7.51,0,13.59,6.09,13.59,13.59v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M368.97,76.21h-22.05c-3.74,0-6.41,3.15-6.49,6.89-.07,3.67-3.07,6.62-6.75,6.62h-1.87c-3.74,0-6.41-3.15-6.49-6.89-.07-3.67-3.07-6.62-6.75-6.62h-22.01c-3.74,0-6.41,3.15-6.49,6.89-.07,3.67-3.07,6.62-6.75,6.62h-1.87c-3.74,0-6.41-3.15-6.49-6.89-.07-3.67-3.07-6.62-6.75-6.62h-21.76c-3.73,0-6.76,3.02-6.76,6.76v40.91c0,3.73,3.02,6.75,6.75,6.75h122.53c3.73,0,6.75-3.02,6.75-6.75v-40.91c0-3.73-3.02-6.75-6.75-6.75Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmmahfyMobileLogo);
export default __webpack_public_path__ + "static/media/Ummahfy Mobile Logo.00d1fed7a8aafdcb95cc6bdf928437d0.svg";
export { ForwardRef as ReactComponent };